import { createContext } from 'react';

import { createStore, Store } from '../../../core/store/store.js';
import { initialState } from '../constants.js';
import { TimeseriesChartState } from '../types/state.js';

export const TimeseriesChartStateContext = createContext<
  Store<TimeseriesChartState>
>(createStore<TimeseriesChartState>(initialState));

TimeseriesChartStateContext['displayName'] = 'TimeseriesChartStateContext';
